import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

const json = () => authHeaders({ "Content-Type": "application/json" });

const getAll = async (params = {}) => {
  const res = await axios.get(`${API_URL}contact-messages`, { headers: authHeaders(), params });
  return res.data;
};

const getOne = async (id) => {
  const res = await axios.post(`${API_URL}contact-messages/show`, { id }, { headers: json() });
  return res.data;
};

// data ma 'id' hovu joiye
const update = async (data) => {
  const res = await axios.post(`${API_URL}contact-messages/update`, data, { headers: json() });
  return res.data;
};

const remove = async (id) => {
  const res = await axios.post(`${API_URL}contact-messages/delete`, { id }, { headers: json() });
  return res.data;
};

export default { getAll, getOne, update, remove };